export default __webpack_public_path__ + "static/media/Avala.b14e788a.svg";